import axios from 'axios';
import * as utils from '../utils';
import { useSnackbarCherre } from 'src/products/core-prospect/hooks';

export const useCreateDeal = (body, isCreateBoth, onClose) => {
  const { enqueueSnackbar } = useSnackbarCherre();

  const submit = async () => {
    try {
      const response = await axios.post(`/api/v1/dealcloud/create`, {
        propertyForm: body.propertyFormState,
        dealForm: body.dealFormState,
      });

      enqueueSnackbar('Deal was created.', utils.getSnackbarProps('success'));
      onClose();
      return response;
    } catch (e) {
      const msg = utils.getErrorMsg(e, 'Failed to create the deal');
      enqueueSnackbar(msg, utils.getSnackbarProps('error'));
    }
  };

  return { submit };
};
